export default __webpack_public_path__ + "static/media/icon-clock-fill.c3d4ea01.svg";